/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Property_UpdatedInputs */

const cs_event_property_updated = /** @type {(inputs: Event_Property_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nemovitost aktualizována`)
};

const en_event_property_updated = /** @type {(inputs: Event_Property_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property updated`)
};

/**
* | output |
* | --- |
* | "Property updated" |
*
* @param {Event_Property_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const event_property_updated = /** @type {((inputs?: Event_Property_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Property_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_property_updated(inputs)
	return cs_event_property_updated(inputs)
});